import React from 'react';
import { useRecoilValue } from 'recoil';
import { LazyImageLoader } from '../../product_detail/components/LazyImageLoader';
import { assetPathFnState } from '../../recoil/atoms';
import { productListState } from '../../recoil/selectors';
import { Link } from '../../root/components/Link';

interface Props {
  hideCTA?: boolean;
}

export const ReturnsDetail: React.FC<Props> = ({ hideCTA = false }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const products = useRecoilValue(productListState);
  const noReturnsProducts = products.filter((product) => !product.isReturnable);

  return (
    <>
      <div>
        <div>
          <h2>Our promise to you</h2>
          <blockquote>
            If you don&apos;t love it, for <em>any</em> reason, we&apos;ll take it back.
          </blockquote>
          <p>
            Not 100% in love? No problem! You have 30 days to return your Sculptwear for a full refund to your original payment method.
            <br />
            Try Honeylove risk-free thanks to free standard shipping on all U.S. returns and exchanges.
          </p>
        </div>
      </div>
      <div>
        {noReturnsProducts.length > 0 && (
          <React.Fragment>
            <p>Please note that returns are not available for the following products:</p>
            <ul>
              {noReturnsProducts.map((p, i) => {
                return <li key={i}>{p.title}</li>;
              })}
              <li>
                Final sale discounted items. The current list can be found <a href="/collections/discounted">here</a>
              </li>
            </ul>
          </React.Fragment>
        )}
        {!hideCTA && (
          <React.Fragment>
            <p>
              <Link dataTrackLabel="Return Policy" dataTrackLocation="Returns Page" href="/pages/return-exchange-policy">
                Return policy &amp; international orders
              </Link>
            </p>
            <Link
              buttonType="primary"
              dataTrackLabel="Start a return"
              dataTrackLocation="Returns Page"
              href="https://returns.honeylove.com/"
              text="Start a return"
            />
          </React.Fragment>
        )}
      </div>
      <div>
        <h2>We stand by our products</h2>
        <p>
          We pour our hearts into creating a product you’ll absolutely love. We make returns simple because we believe everyone deserves the perfect fit. Your
          feedback helps us to constantly improve and update our products so they work for every unique body shape and size.
        </p>
        <p>
          Our Sculptwear is built to last, so it’s important you have time to exchange or return your shapewear before you commit. By offering free shipping on
          returns and exchanges within the U.S., we hope to make it as easy as possible to find the best fit for you.
        </p>
      </div>
      <div>
        <LazyImageLoader
          shouldUseDynamicDimensions={true}
          src={assetPathFn('returns-image-1.jpg')}
          alt="Model posing in Cami Bodysuit"
          style={{ marginTop: '0' }}
        />
      </div>
    </>
  );
};

export default ReturnsDetail;
